import React from 'react';
import { ChevronRight } from 'styled-cssgg';
import styled from 'styled-components';
import cx from 'classnames';
const StyledBreadcrumb = styled.div `
  display: inline-flex;
  align-items: center;
  color: ${() => 'var(--text-color-0)'};
  background-color: ${() => 'var(--bg-color-1)'};
  padding: 2px 8px;
  font-size: 14px;
  cursor: pointer;
`;
const StyledBreadcrumbItem = styled.div `
  display: flex;
  align-items: center;
  p {
    margin: 0px;
  }
  i {
    color: #797979;
    --ggs: 0.75;
  }
`;
export const BreadcrumbItem = (props) => {
    return (React.createElement(StyledBreadcrumbItem, { className: cx('breadcrumb-item', props.className), "data-role": "breadcrumb-item" },
        React.createElement("p", null, props.children),
        React.createElement(ChevronRight, null)));
};
export const Breadcrumb = (props) => {
    return (React.createElement(StyledBreadcrumb, { className: cx('breadcrumb', props.className), "data-role": "breadcrumb" }, props.children));
};
